import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Platform, StyleSheet, TextInput, View } from 'react-native';
import CurrencyInput from 'react-native-currency-input';

import { useColor } from '@/hooks/useColor';

import Text from '../Text';

export type NumericInputProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  prefix?: string;
  delimiter?: string;
  precision?: number;
  maxLength?: number;
  hideError?: boolean;
};

const CurrencyInputField = <T extends FieldValues>({
  name,
  control,
  prefix = '$',
  delimiter = ',',
  precision = 0,
  maxLength = 10,
  hideError = false
}: NumericInputProps<T>) => {
  const colors = useColor();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <View style={style.roundedWithShadow}>
          <View style={style.inputContainer}>
            <CurrencyInput
              prefix={prefix}
              placeholderTextColor={colors.placeholderText}
              delimiter={delimiter}
              precision={precision}
              maxLength={maxLength}
              value={value}
              onChangeValue={onChange}
              onChange={onChange}
              onBlur={onBlur}
              allowFontScaling={false}
              returnKeyLabel={'done'}
              returnKeyType={'done'}
              renderTextInput={(props) => (
                <TextInput
                  {...props}
                  style={[style.inputContainer, Platform.OS === 'web' && ({ outlineStyle: 'none' } as any)]}
                />
              )}
            />
            {!!error?.message && !hideError && <Text style={style.errorText}>{error.message}</Text>}
          </View>
        </View>
      )}
    />
  );
};

export default CurrencyInputField;

const style = StyleSheet.create({
  roundedWithShadow: {
    height: 64,
    backgroundColor: '#F1F1F1',
    justifyContent: 'center',
    paddingHorizontal: 25,
    borderRadius: 50,
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowRadius: 5,
    shadowColor: 'black',
    shadowOpacity: 0.12,
    elevation: 5
  },

  inputContainer: {
    position: 'relative',
    verticalAlign: 'middle',
    justifyContent: 'center',
    fontSize: 40,
    fontWeight: '900'
  },

  errorText: {
    marginTop: 10,
    fontSize: 16,
    color: 'red'
  }
});
